import React from 'react'
import { Button, Typography, theme } from 'antd'
import { UserOutlined, PlusOutlined } from '@ant-design/icons'
import { hexToRGBA } from '../../../../lib/utils'

const { Title } = Typography

const AdmissionsHeader = ({ showModal }) => {
  const { token } = theme.useToken()

  return (
    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '24px', position: 'relative' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)'
        }}
      >
        <UserOutlined style={{ marginRight: '8px', fontSize: '24px', color: token.colorPrimary }} />
        <Title level={4} style={{ margin: 0, color: token.colorPrimary }}>
          Patient Admissions
        </Title>
      </div>
      <div style={{ marginLeft: 'auto', marginRight: '20px' }}>
        <Button
          icon={<PlusOutlined style={{ color: token.colorPrimary }} />}
          onClick={showModal}
          style={{
            background: hexToRGBA(token.colorPrimary, 0.1),
            borderColor: token.colorPrimary,
            color: token.colorPrimary,
            fontWeight: 'bold'
          }}
        >
          New Admission
        </Button>
      </div>
    </div>
  )
}

export default AdmissionsHeader
